import system from '@/http/modules/system'
const state = () => ({
  systemConfigFromStore: {}
})

// getters
const getters = {}

// actions
const actions = {
    getSystemConfigAction({ commit }) {
        return new Promise(resolve => {
          system.getConfigData().then(({data}) => {
            commit('setSystemConfig', data)
            resolve(data)
          })
        })
    }
}

// mutations
const mutations = {
    setSystemConfig(state, data) {
        state.systemConfigFromStore = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}